import { OnInit, Component } from '@angular/core';
import { Router } from '@angular/router';
import { GlobalService } from 'src/app/shared/global.service';
import { UrlService } from 'src/app/shared/services/url.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { AlertService } from 'src/app/shared/services/alert.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CodigosTarjetasStickersModel } from 'src/app/models/codigosTarjetasStickers.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConsultarInformacionCodigoComponent } from './consultar-informacion-codigo/consultar-informacion-codigo.component';
import { VariablesZonaCompartida } from 'src/app/shared/services/VariablesZonaCompartida';

@Component({
    selector: 'administrar-codigo-reutilizable',
    templateUrl: './administrar-codigo-reutilizable.component.html',
    styleUrls: ['./administrar-codigo-reutilizable.component.scss']
})
export class AdministrarCodigoReutilizableComponent implements OnInit {

    public cantidadCodigos: CodigosTarjetasStickersModel[];
    public showDropDownNuevosCodigos: boolean;
    public abrirModal: boolean;
    public filtroNombre: string;

    constructor(
        private router: Router,
        private global: GlobalService,
        private urlService: UrlService,
        private spinner: NgxSpinnerService,
        private alertService: AlertService,
        private modalService: NgbModal,
    ) {
        this.showDropDownNuevosCodigos = false;
        this.cantidadCodigos = [];
        this.abrirModal = false;
    }

    ngOnInit() {
        this.consultaTarjetaStickers();
    }

    buscarPorFiltro() {
        this.vermodal();
    }

 /**
  * abrir modal que muestra la informacion del codigo ingresado
  */
    public vermodal() {
        const modalRef = this.modalService.open(ConsultarInformacionCodigoComponent, { centered: true });
        modalRef.componentInstance.data = this.filtroNombre; // Objeto que se envìa al modal para ediciòn la consulta
    }

    /**
     * Método que consulta la cantidad de Tarjetas y Stickers registrados
     */
    consultaTarjetaStickers() {
        this.spinner.show();
        const serviceProvider = 'consultarCodigosTarjetaStickers';
        const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_ACCVIS);
        this.global.postGenerico(url).subscribe(
            data => {
                this.cantidadCodigos = data;
                this.spinner.hide();
            }, err => {
                this.spinner.hide();
                if (err.status === '500') {
                    this.cathException(err.error.message);
                } else {
                    this.cathException('No se pudo consultar las tarjetas y stickers');
                }
            });
    }

    /**
     * Método que muestra las opciones de crear stickers o tarjetas
     */
    showDropDown() {
        this.showDropDownNuevosCodigos = !this.showDropDownNuevosCodigos;
    }

    /**
     * Método de redirecciòn a crear tarjetas o stickers
     * @param pagina parametro que resive tarjeta o sticker
     */
    crearCodigos(pagina) {
        this.global.zonaCompartida[VariablesZonaCompartida.TIPO_GENRACION] = pagina;
        this.router.navigate(['main/guardar-codigos-reutilizable']);
    }

    /**
     * Método de control de Excepciones
     * @param error  mensaje saliente respecto al error ocurrido
     */
    cathException(error) {
        this.alertService.generateAlertError(error, 'Error');
        this.spinner.hide();
    }
}
